import env from '../../../env/env';

const NO_GOALS_IMAGE = `${env.REACT_APP_STATIC_BASE_URL}marketplace/matches/multimedia/no-goals.png`;
export { NO_GOALS_IMAGE };
